import React, { Component } from "react";
import { Form, FormGroup, Label, Input, Col, Row } from 'reactstrap';
import BlockUi from 'react-block-ui';
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';
import Messages from '../../notifications/Messages'
import Select from 'react-select';
import Errors from '../../notifications/Errors'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import * as khachhangAction from './actions'
import * as khachhangConstant from './constants'
import { storedb } from '../client/storedb'
import * as common from '../../lib/common'
import CheckboxTreeList from "../controls/_CheckboxTreeList";
import _DiemTichLuyEdit from "./_DiemTichLuyEdit"

const listLich = [
  { value: '0', label: 'Chủ nhật' },
  { value: '1', label: 'Thứ 2' },
  { value: '2', label: 'Thứ 3' },
  { value: '3', label: 'Thứ 4' },
  { value: '4', label: 'Thứ 5' },
  { value: '5', label: 'Thứ 6' },
  { value: '6', label: 'Thứ 7' }
];
import { BtnPermissions, BtnType } from '../../lib/BtnPermissions';
import { ButtonExt } from "../controls/ButtonExt"
import AppConfig from "../../config/app";
import DiemTichLuyEdit from "./_DiemTichLuyEdit";

class KhachhangEdit extends Component {
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      item: {
        StoreId: dbContext.getStoreId(),
        TrangThai: AppConfig.KHACHHANG_DANGHOATDONG,
        Rank: "",
      },
      modalEditDiem: false,
      listTinhThanh: [],
      listQuanHuyen: [],
      listPhuongXa: [],
      listMucHopDong: [],
      formError: {},
      formValid: false,
      stores_id: dbContext.getStoreId(),
      selectedOptionLich: null,
      selectedOptionTinhThanh: null,
      selectedOptionQuanHuyen: null,
      selectedOptionPhuongXa: null,
      selectedOptionMucHopDong: null,
      selectedOption: null,
      treeQuanLy: [],
      checkedQuanLy: [],
      multipleValueQuanLy: [],
      idKhEdit: 0
    };
  }
  getParam = (name) => {
    const queryParamsString = this.props.location.search.substring(1),
      searchParams = new URLSearchParams(queryParamsString);
    return searchParams.get(name);
  }
  handleControlChange = (e) => {
    this.props.khachhangUploadError("");
    let { item } = this.state
    item[e.target.name] = e.target.value
    this.setState({ item })
  }
  handleSelectChange = (name, selectedOption) => {
    let { item } = this.state;
    this.props.khachhangUploadError("");
    if (selectedOption.name) {
      switch (selectedOption.name) {
        case "TinhThanh":
          this.setState({ selectedOptionTinhThanh: name, selectedOptionQuanHuyen: null, selectedOptionPhuongXa: null })
          item.RegionId = name.value
          item.RegionName = name.label
          item.RegionCode = name.ma
          this.props.khachhangQuanHuyenListRequest({ ParentId: item.RegionId, Cap: 2 }, (res) => {
            this.setState({
              listQuanHuyen: this.BuildSelectOption(res, "dvhc")
            })
          })
          break;
        case "QuanHuyen":
          this.setState({ selectedOptionQuanHuyen: name })
          item.QuanHuyenId = name.value
          item.QuanHuyenTen = name.label
          this.props.khachhangPhuongXaListRequest({ ParentId: item.QuanHuyenId, Cap: 3 }, (res) => {
            this.setState({
              listPhuongXa: this.BuildSelectOption(res, "dvhc")
            })
          })
          break;
        case "PhuongXa":
          this.setState({ selectedOptionPhuongXa: name })
          item.PhuongXaId = name.value
          item.PhuongXaTen = name.label
          break;
        case "MucHopDong":
          this.setState({ selectedOptionMucHopDong: name })
          item.MucHopDongId = name.value
          item.MucHopDongTen = name.label
          item.HdThamGia = name.label
          break;
        case "LichChamSoc":
          this.setState({ selectedOptionLich: name })
          let arrName = name.map((item) => { return item.label }).join(',');
          let arrValue = name.map((item) => { return item.value }).join(',');
          item.TuyenChamSoc = arrValue;
          item.TuyenChamSocText = arrName;
          break;
        default:
          break;
      }
    } else {
      switch (name) {
        case "TrangThai":
          item.TrangThai = selectedOption.target.value
          break;
        case "LoaiKhachHang":
          item.LoaiKhachHangId = selectedOption.target.value
          item.TenLoaiKhachHang = selectedOption.target[selectedOption.target.selectedIndex].text
          break;
        case "Rank":
          item.Rank = selectedOption.target.value
          item.RankName = selectedOption.target[selectedOption.target.selectedIndex].text
          break;
        default:
          break;
      }
    }
    this.setState({ item })
  }
  handleDateChange = (name, obj) => {
    let { item } = this.state;
    switch (name) {
      case "NgaySinh":
        item.NgaySinh = obj.format();
        break;
      case "NgayKyHd":
        item.NgayKyHd = obj.format();
        break;
      default:
        break;
    }
    this.setState({ item })
  }
  onHandleRemoveQuanLy = () => {
    this.setState({ multipleValueQuanLy: [] })
  }
  onHandleChoiceQuanLy = (nodesChecked) => {
    var multipleValue = [];
    nodesChecked.forEach(function (item) {
      multipleValue.push(item.value);
    });
    let { item } = this.state;
    if (nodesChecked[0].data) {
      item.MaQuanLy = nodesChecked[0].data.SubName
      item.TenQuanLy = nodesChecked[0].data.Name
      item.IdQuanLy = nodesChecked[0].data.Id
    }
    this.setState({ multipleValueQuanLy: multipleValue, item })
  }
  convertToMoment = (date) => {
    if (typeof date == 'string') {
      return moment(date);
    }
    return date;
  }
  Cancel = () => {
    this.featchDetail();
  }
  featchCmb = () => {
    const { cmbListRequest } = this.props;
    let requestData = {
      stores_id: this.state.stores_id,
      page: 1,
      per_page: 200,
    };
    return cmbListRequest(requestData);
  }
  getMucHopDong = () => {
    this.props.khachhangMucHopDongListRequest(null, (res) => {
      this.setState({ listMucHopDong: this.BuildSelectOption(res) })
    })
  }
  featchDetail = () => {
    const { khachhangDetailRequest } = this.props
    let khachHangId = this.getParam("kid");
    var requestData = {
      khach_hang_id: khachHangId || 0,
      store_id: this.state.stores_id
    }
    return khachhangDetailRequest(requestData);
  }
  EditDiemTichLuy = (isChanged) => {
    this.setState({ modalEditDiem: !this.state.modalEditDiem })
    if (isChanged) {
      this.featchDetail()
    }
  }
  Updatekhachhang = () => {
    let formError = {};
    let formValid = true;
    if (!this.state.item.Ma || this.state.item.Ma == "") {
      formError.Ten = 'Bạn chưa nhập mã khách hàng';
    }
    if (!this.state.item.Ten || this.state.item.Ten == "") {
      formError.Ten = 'Bạn chưa nhập tên khách hàng';
    }
    if (!this.state.item.DiaChi || this.state.item.DiaChi == "") {
      formError.DiaChi = 'Bạn chưa nhập địa chỉ';
    }
    if (!this.state.item.NguoiDaiDien || this.state.item.NguoiDaiDien == "") {
      formError.NguoiDaiDien = 'Bạn chưa nhập người đại diện';
    }
    if (!this.state.item.DienThoai || this.state.item.DienThoai == "") {
      formError.DienThoai = 'Bạn chưa nhập số di động';
    }
    if (!this.state.item.RegionId) {
      formError.RegionId = 'Bạn chưa nhập tỉnh thành';
    }
    if (!this.state.item.QuanHuyenId) {
      formError.QuanHuyenId = 'Bạn chưa nhập quận huyện';
    }
    if (!this.state.item.MaQuanLy) {
      formError.IdQuanLy = 'Bạn chưa nhập người quản lý';
    }
    if (this.state.item.TrangThai == -1) {
      formError.TrangThai = 'Bạn chưa nhập trạng thái';
    }
    if (!this.state.item.NgaySinh || this.state.item.NgaySinh == null) {
      formError.NgaySinh = 'Bạn chưa nhập ngày sinh';
    }
    if (!this.state.item.MucHopDongId || this.state.item.MucHopDongId == "") {
      formError.MucHopDongId = 'Bạn chưa nhập mức hợp đồng';
    }
    for (var prp in formError) {
      if (prp && formError[prp] != '') {
        formValid = false;
        break;
      }
    }
    this.setState({ formError, formValid });
    if (formValid) {
      let { item } = this.state;
      item.StoreId = this.state.stores_id;
      this.props.khachhangUpdateRequest(item);
    }
  }
  BackToListkhachhang = (item, e) => {
    this.props.history.push('/khachhang');
  }
  componentDidMount() {
    this.featchCmb();
    this.getMucHopDong();
    this.featchDetail();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.khachhangEdit.type == khachhangConstant.KHACHHANG_DETAIL_SUCCESS) {
      let { item } = nextProps.khachhangEdit;
      if (item.KhachHangId && item.KhachHangId > 0) {
        var checkedQuanLy = [];
        checkedQuanLy.push(item.IdQuanLy)
        this.props.khachhangQuanHuyenListRequest({ ParentId: item.RegionId, Cap: 2 }, (res) => {
          this.setState({
            listQuanHuyen: this.BuildSelectOption(res, "dvhc")
          })
        })
        this.props.khachhangPhuongXaListRequest({ ParentId: item.QuanHuyenId, Cap: 3 }, (res) => {
          this.setState({
            listPhuongXa: this.BuildSelectOption(res, "dvhc")
          })
        })
        this.setState({
          item: item,
          checkedQuanLy,
          selectedOptionTinhThanh: { value: item.RegionId, label: item.RegionName },
          selectedOptionQuanHuyen: { value: item.QuanHuyenId, label: item.QuanHuyenTen },
          selectedOptionPhuongXa: { value: item.PhuongXaId, label: item.PhuongXaTen },
          selectedOptionMucHopDong: { value: item.MucHopDongId, label: item.MucHopDongTen },
          selectedOptionLich: this.BuildSelectLich(item.TuyenChamSoc, item.TuyenChamSocText),
          idKhEdit: item.KhachHangId
        });
      }
    } else if (nextProps.khachhangEdit.type == khachhangConstant.KHACHHANG_UPDATE_SUCCESS) {
      this.props.history.push("/khachhang");
    } else if (nextProps.khachhangEdit.type == khachhangConstant.KHACHHANG_CMB_LIST_SUCCESS) {
      let { listCmb } = nextProps.khachhangEdit;
      let { item } = this.state;
      this.setState({
        treeQuanLy: listCmb.listQuanLy,
        listTinhThanh: this.BuildSelectOption(listCmb.listDvhc, "TINHTHANH"),
        item
      });
    }
  }
  BuildSelectLich(value, text) {
    let opt = []
    if (text != '' && text != null) {
      let arrText = text.split(',');
      let arrValue = (value || '').split(',');
      if (arrValue.length > 0) {
        for (var i in arrValue) {
          opt.push({ label: arrText[i], value: arrValue[i] });
        }
      }
    }
    return opt;
  }
  BuildSelectOption(list, type) {
    var options = [];
    if (list && list.length > 0) {
      if (type == "TINHTHANH") {
        list.map((item) => { options.push({ value: item.TinhThanhId, label: item.Ten, ma: item.Ma }) });
      } else {
        list.map((item) => { options.push({ value: item.Id, label: item.Ten, ma: item.Ma }) });
      }
    }
    return options;
  }
  render() {
    const {
      formError,
      item,
      selectedOptionLich,
      selectedOptionTinhThanh,
      selectedOptionQuanHuyen,
      selectedOptionPhuongXa,
      selectedOptionMucHopDong,
      listTinhThanh,
      listQuanHuyen,
      listPhuongXa,
      listMucHopDong,
      treeQuanLy,
      idKhEdit
    } = this.state;

    const {
      khachhangEdit: {
        isRequesting,
        errors,
        messages
      },
    } = this.props

    const khachHangStatusEnum = common.GetKhachHangStatusValue().map(item => {
      const text = common.getKhachHangStatusText(item)
      return { value: item, text: text.result, class: text.class }
    })
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={false} >
          <Form className="row">
            <FormGroup className="col-sm-4">
              <Label >Mã khách hàng <span className="text-red">(*)</span></Label>
              <Input type="text" name="Ma" placeholder="Mã khách hàng" value={item.Ma || ''} readOnly={idKhEdit > 0 ? true : false} onChange={this.handleControlChange.bind(this)} />
              <em className="error invalid-feedback">{formError.Ma}</em>
            </FormGroup>
            <FormGroup className="col-sm-4">
              <Label >Tên khách hàng<span className="text-red">(*)</span></Label>
              <Input type="text" name="Ten" placeholder="Tên khách hàng" value={item.Ten || ''} onChange={this.handleControlChange.bind(this)} />
              <em className="error invalid-feedback">{formError.Ten}</em>
            </FormGroup>
            <FormGroup className="col-sm-4">
              <Label >Địa chỉ <span className="text-red">(*)</span></Label>
              <Input type="text" name="DiaChi" placeholder="Địa chỉ" value={item.DiaChi || ''} onChange={this.handleControlChange.bind(this)} />
              <em className="error invalid-feedback">{formError.DiaChi}</em>
            </FormGroup>
            <FormGroup className="col-sm-4">
              <Label >Người đại diện<span className="text-red">(*)</span></Label>
              <Input type="text" name="NguoiDaiDien" placeholder="Người đại diện" value={item.NguoiDaiDien || ''} onChange={this.handleControlChange.bind(this)} />
              <em className="error invalid-feedback">{formError.NguoiDaiDien}</em>
            </FormGroup>
            <FormGroup className="col-sm-4">
              <Label >Di động<span className="text-red">(*)</span></Label>
              <Input type="text" name="DienThoai" placeholder="Di động" value={item.DienThoai || ''} onChange={this.handleControlChange.bind(this)} />
              <em className="error invalid-feedback">{formError.DienThoai}</em>
            </FormGroup>
            <FormGroup className="col-sm-4">
              <div><Label >Ngày sinh  <span className="text-red">(*)</span></Label></div>
              <DatePicker name="NgaySinh" dateFormat="DD/MM/YYYY" selected={this.convertToMoment(item.NgaySinh)} onChange={this.handleDateChange.bind(this, "NgaySinh")} className={"form-control"} />
              <em className="error invalid-feedback">{formError.NgaySinh}</em>
            </FormGroup>
            <FormGroup className="col-sm-4">
              <Label>Tỉnh/Thành phố<span className="text-red">(*)</span></Label>
              <Select
                name="TinhThanh"
                placeholder="Chọn tỉnh thành"
                value={selectedOptionTinhThanh}
                onChange={this.handleSelectChange}
                options={listTinhThanh}
              />
              <em className="error invalid-feedback">{formError.RegionId}</em>
            </FormGroup>
            <FormGroup className="col-sm-4">
              <Label>Quận/Huyện<span className="text-red">(*)</span></Label>
              <Select
                name="QuanHuyen"
                placeholder="Chọn quận/huyện"
                value={selectedOptionQuanHuyen}
                onChange={this.handleSelectChange}
                options={listQuanHuyen}
              />
              <em className="error invalid-feedback">{formError.QuanHuyenId}</em>
            </FormGroup>
            <FormGroup className="col-sm-4">
              <Label>Phường/Xã</Label>
              <Select
                name="PhuongXa"
                placeholder="Chọn phường/xã"
                value={selectedOptionPhuongXa}
                onChange={this.handleSelectChange}
                options={listPhuongXa}
              />
              <em className="error invalid-feedback">{formError.PhuongXaId}</em>
            </FormGroup>
            <FormGroup className="col-sm-4">
              <Label>Quản lý<span className="text-red">(*)</span></Label>
              <CheckboxTreeList
                placeholder={`--Chọn quản lý--`}
                nodes={treeQuanLy}
                checked={this.state.checkedQuanLy}
                isMultiChoice={false}
                onHandleRemove={(item) => this.onHandleRemoveQuanLy(item)}
                onChoice={e => this.onHandleChoiceQuanLy(e)}
              />
              <em className="error invalid-feedback">{formError.IdQuanLy}</em>
            </FormGroup>
            <FormGroup className="col-sm-4">
              <Label >Mã số thuế</Label>
              <Input type="text" name="MaSoThue" placeholder="Mã số thuế" value={item.MaSoThue || ''} onChange={this.handleControlChange.bind(this)} />
              <em className="error invalid-feedback">{formError.MaSoThue}</em>
            </FormGroup>
            <FormGroup className="col-sm-4">
              <Label>Loại khách hàng</Label>
              <select name="LoaiKhachHangId" className="form-control" value={item.LoaiKhachHangId || -1} onChange={this.handleSelectChange.bind(this, "LoaiKhachHang")}>
                <option value={-1}>---Chọn nhóm khách hàng---</option>
                <option value={1}>Khách hàng mới</option>
                <option value={2}>Khách hàng lẻ</option>
                <option value={3}>Khách hàng hợp đồng</option>
              </select>
              <em className="error invalid-feedback">{formError.LoaiKhachHangId}</em>
            </FormGroup>
            <FormGroup className="col-sm-4">
              <Label >Điện thoại</Label>
              <Input type="text" name="Mobile" placeholder="Điện thoại" value={item.Mobile || ''} onChange={this.handleControlChange.bind(this)} />
              <em className="error invalid-feedback">{formError.Mobile}</em>
            </FormGroup>
            <FormGroup className="col-sm-4">
              <div><Label >Ngày ký HĐ</Label></div>
              <DatePicker name="NgayKyHd" dateFormat="DD/MM/YYYY" selected={this.convertToMoment(item.NgayKyHd)} onChange={this.handleDateChange.bind(this, "NgayKyHd")} className={"form-control"} />
            </FormGroup>
            <FormGroup className="col-sm-4">
              <div><Label >Điểm tích luỹ</Label></div>
              <div className="input-group input-group-md display-table">
                <div className="input-group-prepend  display-table-cell">
                  <Input type="text" name="DiemTichLuy" disabled={true} maxLength="6" placeholder="0" value={item.DiemTichLuy || ''} />
                </div>
                <div className={"display-table-cell"}>
                  <ButtonExt noMb={true}
                    color="primary"
                    iconClass="fa-pencil"
                    displayText="Sửa"
                    btnClick={(e) => this.EditDiemTichLuy()}
                    permission={BtnPermissions.KhachHang.UPDATE_DIEM_TICH_LUY} />
                </div>
              </div>
            </FormGroup>
            <FormGroup className="col-sm-4">
              <Label >Lịch chăm sóc</Label>
              <Select isMulti
                name="LichChamSoc"
                value={selectedOptionLich}
                placeholder="Chọn lịch làm việc"
                onChange={this.handleSelectChange}
                options={listLich} />
              <em className="error invalid-feedback">{formError.DvtId}</em>
            </FormGroup>
            <FormGroup className="col-sm-4">
              <Label >Ngân hàng</Label>
              <Input type="text" name="NganHang" placeholder="Ngân hàng" value={item.NganHang || ''} onChange={this.handleControlChange.bind(this)} />
              <em className="error invalid-feedback">{formError.NganHang}</em>
            </FormGroup>
            <FormGroup className="col-sm-4">
              <Label >Số tài khoản</Label>
              <Input type="text" name="SoTaiKhoan" placeholder="Số tài khoản" value={item.SoTaiKhoan || ''} onChange={this.handleControlChange.bind(this)} />
              <em className="error invalid-feedback">{formError.SoTaiKhoan}</em>
            </FormGroup>
            <FormGroup className="col-sm-4">
              <Label >Chi nhánh</Label>
              <Input type="text" name="ChiNhanh" placeholder="Chi nhánh" value={item.ChiNhanh || ''} onChange={this.handleControlChange.bind(this)} />
              <em className="error invalid-feedback">{formError.ChiNhanh}</em>
            </FormGroup>
            <FormGroup className="col-sm-4">
              <Label>Trạng thái<span className="text-red">(*)</span></Label>
              <select name="TrangThai" className="form-control" value={item.TrangThai || -1} onChange={this.handleSelectChange.bind(this, "TrangThai")}>
                <option value={-1}>---Chọn trạng thái khách hàng---</option>
                {(khachHangStatusEnum.map((item, index) => (
                  <option key={index} value={item.value}>
                    {item.text}
                  </option>
                )))}
              </select>
              <em className="error invalid-feedback">{formError.TrangThai}</em>
            </FormGroup>
            <FormGroup className="col-sm-4">
              <Label>Xếp hạng</Label>
              <select name="Rank" className="form-control" value={(item.Rank == undefined || item.Rank == null) ? "" : item.Rank} onChange={this.handleSelectChange.bind(this, "Rank")}>
                <option value="">---Chọn xếp hạng khách hàng---</option>
                <option value={0}>Khách hàng tiềm năng</option>
                <option value={1}>Khách hàng thường xuyên</option>
                <option value={10}>Khách hàng đặc biệt</option>
              </select>
              <em className="error invalid-feedback">{formError.Rank}</em>
            </FormGroup>
            <FormGroup className="col-sm-4">
              <Label>Mức hợp đồng<span className="text-red">(*)</span></Label>
              <Select
                name="MucHopDong"
                placeholder="Chọn mức hợp đồng"
                value={selectedOptionMucHopDong}
                onChange={this.handleSelectChange}
                options={listMucHopDong}
              />
              <em className="error invalid-feedback">{formError.MucHopDongId}</em>
            </FormGroup>
            <FormGroup className="col-sm-4">
              <Label >Hợp đồng tham gia</Label>
              <Input type="text" name="HdThamGia" placeholder="Hợp đồng tham gia" value={item.HdThamGia || ''} onChange={this.handleControlChange.bind(this)} />
              <em className="error invalid-feedback">{formError.HdThamGia}</em>
            </FormGroup>
          </Form>
          <div className="w-100 mb-2">
            <ButtonExt btnClass="mr-1"
              color="success"
              iconClass="fa-list"
              displayText="Danh sách"
              btnClick={() => this.BackToListkhachhang()}
              permission={""} />
            <ButtonExt btnClass="mr-1"
              color="primary"
              iconClass="fa-save"
              displayText="Lưu"
              btnClick={() => this.Updatekhachhang()}
              permission={BtnPermissions.KhachHang.ADD_OR_UPDATE} />
          </div>
          <DiemTichLuyEdit
            modalEditDiem={this.state.modalEditDiem}
            onClose={this.EditDiemTichLuy}
            onSave={this.props.khachhangUpdateDiemTLRequest}
            Id={item.KhachHangId}
            DiemTichLuy={item.DiemTichLuy}
            Loai={khachhangConstant.LoaiKhachHang.Default}
          />
        </BlockUi>
        <Row>
          <Col md="12">
            {!isRequesting && !!errors.length && (
              <Errors errors={errors} />
            )}
            {!isRequesting && !!messages.length && (
              <Messages messages={messages} />
            )}
          </Col>
        </Row>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  khachhangEdit: state.khachhangEdit,
})
const connected = connect(mapStateToProps, {
  khachhangDetailRequest: khachhangAction.khachhangDetailRequest,
  khachhangUpdateRequest: khachhangAction.khachhangUpdateRequest,
  khachhangListRequest: khachhangAction.khachhangListRequest,
  cmbListRequest: khachhangAction.cmbListRequest,
  khachhangUploadError: khachhangAction.khachhangUploadError,
  khachhangUpdateDiemTLRequest: khachhangAction.khachhangUpdateDiemTLRequest,
  khachhangMucHopDongListRequest: khachhangAction.khachhangMucHopDongListRequest,
  khachhangQuanHuyenListRequest: khachhangAction.khachhangQuanHuyenListRequest,
  khachhangPhuongXaListRequest: khachhangAction.khachhangPhuongXaListRequest,
})(KhachhangEdit)

const formed = reduxForm({
  form: 'khachhangEdit',
})(connected)

export default formed;


// WEBPACK FOOTER //
// ./src/views/KhachHang/KhachhangEdit.js